"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { MapPin, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const towns = [{
  name: "Acle",
  major: false
}, {
  name: "Attleborough",
  major: false
}, {
  name: "Aylsham",
  major: false
}, {
  name: "Beccles",
  major: false
}, {
  name: "Bungay",
  major: false
}, {
  name: "Cromer",
  major: false
}, {
  name: "Dereham",
  major: true
}, {
  name: "Diss",
  major: false
}, {
  name: "Downham Market",
  major: false
}, {
  name: "Fakenham",
  major: false
}, {
  name: "Gorleston",
  major: false
}, {
  name: "Great Yarmouth",
  major: true
}, {
  name: "Harleston",
  major: false
}, {
  name: "Hingham",
  major: false
}, {
  name: "Holt",
  major: false
}, {
  name: "Hunstanton",
  major: false
}, {
  name: "King's Lynn",
  major: true
}, {
  name: "Loddon",
  major: false
}, {
  name: "Long Stratton",
  major: false
}, {
  name: "Lowestoft",
  major: true
}, {
  name: "North Walsham",
  major: false
}, {
  name: "Norwich",
  major: true
}, {
  name: "Reepham",
  major: false
}, {
  name: "Sheringham",
  major: false
}, {
  name: "Sprowston",
  major: false
}, {
  name: "Stalham",
  major: false
}, {
  name: "Swaffham",
  major: false
}, {
  name: "Taverham",
  major: false
}, {
  name: "Thetford",
  major: true
}, {
  name: "Watton",
  major: false
}, {
  name: "Wells-next-the-Sea",
  major: false
}, {
  name: "Wymondham",
  major: true
}];
export default function TownsWeFrequentlyVisit() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="towns-we-frequently-visit" className="bg-background py-16 sm:py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 sm:px-6">
        <div ref={ref} className={cn("max-w-5xl mx-auto transition-all duration-700 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8")}>
          <div className="text-center mb-12">
            <h2 className="text-3xl font-bold tracking-tight text-foreground sm:text-4xl mb-4">
              Towns We Frequently Visit
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Our mobile units are constantly on the move across Norfolk and East
              Anglia. We provide rapid response coverage to all major towns and
              surrounding villages.
            </p>
          </div>

          <TooltipProvider>
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 sm:gap-4">
              {towns.map((town, i) => {
              const isMajor = town.major;
              const BadgeComponent = <Badge variant="secondary" className={cn("w-full justify-between py-2.5 px-4 text-sm font-medium transition-all duration-300 cursor-default group border border-transparent", "bg-muted text-muted-foreground hover:text-white", "hover:bg-[var(--ring)] hover:shadow-[0_0_15px_var(--ring)] hover:border-[var(--ring)]")}>
                    <span className="flex items-center gap-2">
                      <MapPin className="size-3.5 opacity-50 group-hover:opacity-100 transition-opacity" />
                      {town.name}
                    </span>
                    {isMajor && <Zap className="size-3.5 text-[var(--ring)] group-hover:text-white transition-colors" />}
                  </Badge>;
              return <div key={town.name} data-index={i}>
                    {isMajor ? <Tooltip delayDuration={100}>
                        <TooltipTrigger asChild>
                          {BadgeComponent}
                        </TooltipTrigger>
                        <TooltipContent side="top" className="bg-secondary text-secondary-foreground border-border">
                          <p className="flex items-center gap-2 font-medium">
                            <Zap className="size-3 text-[var(--ring)]" />
                            Tech available in this area
                          </p>
                        </TooltipContent>
                      </Tooltip> : BadgeComponent}
                  </div>;
            })}
            </div>
          </TooltipProvider>

          <div className="mt-12 text-center">
            <p className="text-sm text-muted-foreground bg-muted/50 inline-block px-4 py-2 rounded-full border border-border/50">
              Don&apos;t see your location? We likely cover it too. Call us for confirmation.
            </p>
          </div>
        </div>
      </div>
    </section>;
}